import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/nav";
import Footer from "./components/footer";

import Home from "./screens/home";
import About from "./screens/about";
import Contact from "./screens/contact";
import Community from "./screens/community";
import Article from "./screens/article";
import Articlet from "./screens/articlet";
import Category from "./screens/category";

import Search from "./screens/search";
import SearchByTag from "./screens/searchByTag";

import MainEditor from "./screens/editor";
import EditEditor from "./screens/editEditor.js";

import SignUp from "./screens/signup";
import Login from "./screens/login";
import Admin from "./screens/admin";

import Profile from "./screens/profile";
import MyPage from "./screens/my";


import Monthly from "./screens/monthly";
import MonthlyEditor from "./screens/monthlyEditor";
import MonthlyArticle from "./screens/monthlyArticle";
import Event from "./screens/event";
import News from "./screens/news";


import AboutExpert from "./screens/expert";

import Form from "./screens/form";


import "./css/App.css";

import AppWrapper from "./components/tokenChecker";
import FloatTools from "./components/floattools";

import { ToastProvider } from "./components/ToastProvider";


function App() {
  return (
    <Router>
      <AppWrapper>
        <ToastProvider>
        <FloatTools />
        <Navbar />
        <div className="content-back-color">
          <div className="content">
            <div className="content-main-color">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/community" element={<Community />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />


                <Route path="/community/article/:id" element={<Article />} />
                <Route path="/community/articleD/:id" element={<Articlet />} />
                <Route path="/community/editor/:id" element={<MainEditor />} />
                <Route path="/community/:id" element={<Category />} />
                <Route path="/community/edit/:id" element={<EditEditor />} />

                <Route path="/search/:keyword" element={<Search />} />
                <Route path="/search/tag/:keyword" element={<SearchByTag />} />

                <Route path="/monthly" element={<Monthly />} />
                <Route path="/monthly/write" element={<MonthlyEditor />} />
                <Route path="/monthly/article/:id" element={<MonthlyArticle />} />
                <Route path="/event" element={<Event />} />
                <Route path="/news" element={<News />} />


                <Route path="/profile/:id" element={<Profile />} />


                <Route path="/signup" element={<SignUp />} />
                <Route path="/login" element={<Login />} />
                <Route path="/my" element={<MyPage />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/form" element={<Form />} />

                




                <Route path="/expert" element={<AboutExpert  />} />
              </Routes>
            </div>
          </div>
        </div>

        <Footer />
        </ToastProvider>
      </AppWrapper>
    </Router>
  );
}

export default App;
